import Amplify from '@aws-amplify/core';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { Component } from 'react';
import ReactGA from 'react-ga';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppConfig, ConfigureAmplify } from 'toca-config';
import './App.css';
import './TransitionAnimation.css';
import UserPortalRoutes from './views/UserPortalRoutes';

import {
  GA_TRACKER_NAME,
  GA_TRACKING_ID,
  GTM_TRACKER_NAME,
  GTM_TRACKING_ID,
} from 'config/Constants';

ReactGA.initialize([
  {
    trackingId: GA_TRACKING_ID,
    gaOptions: {
      name: GA_TRACKER_NAME,
    },
  },
  {
    trackingId: GTM_TRACKING_ID,
    gaOptions: {
      name: GTM_TRACKER_NAME,
    },
  },
]);

ConfigureAmplify(Amplify);

class App extends Component {
  render() {
    return (
      <Router>
        <UserPortalRoutes />
      </Router>
    );
  }
}

export default withLDProvider({
  clientSideID: AppConfig.launchDarklyClientId,
  context: {
    kind: 'user',
    key: AppConfig.launchDarklyDefaultUser,
  },
})(App);
